import React from 'react'

const BlueDoubleTickIcon = () => {
    return (
        <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5178 2.2154C13.7958 1.93736 13.7958 1.48657 13.5178 1.20853C13.2398 0.930491 12.789 0.930491 12.511 1.20853L4.94816 8.7713L2.2154 6.03857C1.93736 5.76054 1.48657 5.76054 1.20853 6.03857C0.93049 6.31659 0.93049 6.7674 1.20853 7.04542L4.44473 10.2816C4.72276 10.5597 5.17356 10.5597 5.45159 10.2816L13.5178 2.2154Z" fill="#111AE9" stroke="#111AE9" strokeWidth="0.5" />
            <path d="M17.7914 2.2154C18.0694 1.93736 18.0694 1.48657 17.7914 1.20853C17.5133 0.930491 17.0626 0.930491 16.7845 1.20853L8.71828 9.27472C8.44026 9.55282 8.44026 10.0036 8.71828 10.2816C8.9963 10.5597 9.44712 10.5597 9.72514 10.2816L17.7914 2.2154Z" fill="#111AE9" stroke="#111AE9" strokeWidth="0.5" />
        </svg>

    )
}

export default BlueDoubleTickIcon